import { render } from "./WalletUser.vue?vue&type=template&id=105efbc6"
import script from "./WalletUser.vue?vue&type=script&lang=js"
export * from "./WalletUser.vue?vue&type=script&lang=js"

import "./WalletUser.vue?vue&type=style&index=0&id=105efbc6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__